export const truncateText = (text, limit = 30) => {
    if (text.length <= limit) return text;
    return text.slice(0, limit).trim() + "...";
};

export const ellipsisText = (text, maxLength = 30) => {
  if (!text) return "";
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
}
